import script from "./InterfaceConfigList.vue?vue&type=script&setup=true&lang=js"
export * from "./InterfaceConfigList.vue?vue&type=script&setup=true&lang=js"

import "./InterfaceConfigList.vue?vue&type=style&index=0&id=fcce92e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcce92e6"]])

export default __exports__